"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.podiumColours = exports.LEADERBOARD_VERSIONS_SIZE = exports.LEADERBOARD_PREVIEW_SIZE = exports.LEADERBOARD_PAGE_SIZE = void 0;
var chartColors_1 = require("../../../../components/charts/chartColors");
var LEADERBOARD_PAGE_SIZE = 15;
exports.LEADERBOARD_PAGE_SIZE = LEADERBOARD_PAGE_SIZE;
var LEADERBOARD_VERSIONS_SIZE = 50;
exports.LEADERBOARD_VERSIONS_SIZE = LEADERBOARD_VERSIONS_SIZE;
var LEADERBOARD_PREVIEW_SIZE = 3;
exports.LEADERBOARD_PREVIEW_SIZE = LEADERBOARD_PREVIEW_SIZE;
var podiumColours = { 1: chartColors_1.chartColors.warning.base, 2: chartColors_1.chartColors.muted.base, 3: "#B45309" };
exports.podiumColours = podiumColours;
